<template>
    <div class="banner bng-casino-banner-sport">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/mobile/sport.jpg' : '/static/banners/casino-home-banner/desktop/sport.jpg'"
        />
        <div class="content">
            <div>{{"components.common.banners.casino-banners.sport.msg1" | translate}}</div>
            <div>{{"components.common.banners.casino-banners.sport.msg2" | translate}}</div>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'sport-home' }">{{"components.common.banners.casino-banners.sport.bet" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-sport',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/sport.vue